<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
    />

    <!--    종사자 정보-->
    <div class="mt-5">
      <vs-row class="my-4">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 종사자 정보</h5>
        </vs-col>
      </vs-row>
      <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">사번</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_1 }}</p>
          <ml-input
            v-else
            v-model="form.inputB_1"
            class="w-full flex-1"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">부서명</div>
          <span v-if="isPrint" class="print-input"> {{ form.companyName }} </span>
          <CompanySelector
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            v-model="form.inputB_2"
            placeholder="선택"
            @select="targetCompany"
          ></CompanySelector>
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">성명</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_4 }}</p>
          <ml-input
            v-else
            v-model="form.inputB_4"
            class="w-full flex-1"
          />
        </div>


        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">나이</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_5 }}</p>
          <ml-input
            v-else
            v-model="form.inputB_5"
            class="w-full flex-1"
            type="number"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">구분</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_6 }}</p>
          <vs-select :disabled="board.readonly" v-else v-model="form.inputB_6" autocomplete class="w-full flex-1">
            <vs-select-item v-for="option of options['구분']" :text="option" :value="option" :key="option" />
          </vs-select>
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">직종</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_7 }}</p>
          <vs-select :disabled="board.readonly" v-else v-model="form.inputB_7" autocomplete class="w-full flex-1">
            <vs-select-item v-for="option of options['직종']" :text="option" :value="option" :key="option" />
          </vs-select>
        </div>


        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">입사일</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_8 }}</p>
          <date-selector v-else class="w-full flex-1" v-model="form.inputB_8" :readonly="board.readonly" />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">근속연수</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_9 }}</p>
          <ml-input
            v-else
            v-model="form.inputB_9"
            class="w-full flex-1"
            type="number"
            placeholder="입사일로부터 현재까지 실시간 자동입력"
            :readonly="true"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">연락처</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_10 }}</p>
          <ml-input
            v-else
            v-model="form.inputB_10"
            class="w-full flex-1"
          />
        </div>

        <div class="col-span-12 flex items-center">
          <div class="label-text mr-4">복용중 약물</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_11 }}</p>
          <ml-input
            v-else
            v-model="form.inputB_11"
            class="w-full flex-1"
          />
        </div>
      </div>
    </div>


    <!--    종사자 기본정보-->
    <div class="mt-8">
      <vs-row class="my-4">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 종사자 기본정보</h5>
        </vs-col>
      </vs-row>
      <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">질병력</div>
          <p v-if="isPrint" class="print-input">{{ form.inputC_1 }}</p>
          <ml-input
            v-else
            v-model="form.inputC_1"
            class="w-full flex-1"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">진료병원/주기</div>
          <p v-if="isPrint" class="print-input">{{ form.inputC_2 }}</p>
          <ml-input
            v-else
            v-model="form.inputC_2"
            class="w-full flex-1"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">가족력</div>
          <p v-if="isPrint" class="print-input">{{ form.inputC_3 }}</p>
          <ml-input
            v-else
            v-model="form.inputC_3"
            class="w-full flex-1"
          />
        </div>


        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">음주</div>
          <p v-if="isPrint" class="print-input">{{ form.inputC_4 }}</p>
          <ml-input
            v-else
            v-model="form.inputC_4"
            class="w-full flex-1"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">흡연</div>
          <p v-if="isPrint" class="print-input">{{ form.inputC_5 }}</p>
          <ml-input
            v-else
            v-model="form.inputC_5"
            class="w-full flex-1"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">운동</div>
          <p v-if="isPrint" class="print-input">{{ form.inputC_6 }}</p>
          <ml-input
            v-else
            v-model="form.inputC_6"
            class="w-full flex-1"
          />
        </div>
      </div>
    </div>

    <!-- 일반 검진-->
    <table361-general-checkup
      class="mt-5"
      :list="form['일반검진']"
      @updateList="updateList1"
      :isPrint="isPrint"
      :isReadonly="board.readonly"
    />

    <!-- 건강상담-->
    <table361-health-counseling
      class="mt-5"
      :list="form['건강상담']"
      @updateList="updateList2"
      :isPrint="isPrint"
      :isReadonly="board.readonly"
    />

    <!-- 배치전 검진-->
    <table361-general-checkup
      class="mt-5"
      :list="form['배치전 검진']"
      @updateList="updateList3"
      :isPrint="isPrint"
      :isReadonly="board.readonly"
      title="배치전 검진"
      determination-label="특수건강진단 건강관리구분 판정"
      :determination-options="determinationOptions['배치전 검진']"
    />

    <!-- 배치후 검진-->
    <table361-general-checkup
      class="mt-5"
      :list="form['배치후 검진']"
      @updateList="updateList4"
      :isPrint="isPrint"
      :isReadonly="board.readonly"
      title="배치후 검진"
      determination-label="특수건강진단 건강관리구분 판정"
      :determination-options="determinationOptions['배치후 검진']"
    />

    <!-- 특수검진-->
    <table361-general-checkup
      class="mt-5"
      :list="form['특수검진']"
      @updateList="updateList5"
      :isPrint="isPrint"
      :isReadonly="board.readonly"
      title="특수검진"
      determination-label="특수건강진단 건강관리구분 판정"
      :determination-options="determinationOptions['특수검진']"
    />

    <!-- 파일첨부 -->
    <file-upload-module
      id="fileList"
      class="w-full mt-4"
      v-model="form.fileList"
      :is-print="isPrint"
      :readonly="board.readonly"
    ></file-upload-module>
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import CompanySelector from "@/components/selector/CompanySelector.vue";
import DateSelector from "@/components/selector/DateSelector.vue";
import Table361GeneralCheckup from "@/components/Table361GeneralCheckup.vue";
import Table361HealthCounseling from "@/components/Table361HeathCounseling.vue";

export default {
  components: {
    Table361HealthCounseling,
    Table361GeneralCheckup,
    DateSelector,
    CompanySelector,
    FieldSelectModule,
    FileUploadModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      form: {
        "stdInfo": {},
        "inputB_1": '',
        "inputB_2": '',
        "inputB_3": '',
        "inputB_4": '',
        "inputB_5": '',
        "inputB_6": '',
        "inputB_7": '',
        "inputB_8": '',
        "inputB_9": '',
        "inputB_10": '',
        "inputB_11": '',
        "inputC_1": '',
        "inputC_2": '',
        "inputC_3": '',
        "inputC_4": '',
        "inputC_5": '',
        "inputC_6": '',
        "companyName": '',
        "fileList": [],
        '일반검진': [{}],
        '건강상담': [{}],
        '배치전 검진': [{}],
        '배치후 검진': [{}],
        '특수검진': [{}],
      },
      options: {
        '구분' : ["사무직", "현업 - 청사 등 유지관리", "현업 - 도로의 유지·보수 종사자", "현업 - 환경미화종사자", "현업 - 폐기물 수거처리", "현업 - 공원·녹지 유지관리", "현업 - 산림조사·보호", "현업 - 조리시설", '현업', '노동자', '청원경찰', "기타"],
        '직종' : ['공무원', '공무직', ' 임기제', '기간제', '기능직', '근로자', '공공근로', '노인 일자리', '장애인 일자리', '지역공동체', '자활', '기타']
      },
      determinationOptions: {
        '일반검진' : ['C2', 'D2'],
        '배치전 검진' : ['A', 'C1', 'C2', 'CN', 'D1', 'D2', 'R'],
        '배치후 검진' : ['A', 'C1', 'C2', 'CN', 'D1', 'D2', 'R'],
        '특수검진' : ['A', 'C1', 'C2', 'CN', 'D1', 'D2', 'R'],
      },
    };
  },
  methods: {
    targetCompany (value) {
      this.form.companyName = value.com_name
    },
    updateList1(value) {
      this.form['일반검진'] = value;
    },
    updateList2(value) {
      this.form['건강상담'] = value;
    },
    updateList3(value) {
      this.form['배치전 검진'] = value;
    },
    updateList4(value) {
      this.form['배치후 검진'] = value;
    },
    updateList5(value) {
      this.form['특수검진'] = value;
    }
  },
};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}
</style>
